import { Controller } from "@hotwired/stimulus"

// Keeps a draft of a free tool form in this browser only (file inputs are never stored).
export default class extends Controller {
  static values = { storageKey: String, restore: Boolean }

  connect() {
    if (this.restoreValue) this.restore()
  }

  save() {
    try {
      localStorage.setItem(this.storageKeyValue, JSON.stringify(this.fields().map((field) => [field.name, field.value])))
    } catch {}
  }

  clear() {
    try { localStorage.removeItem(this.storageKeyValue) } catch {}
    this.element.querySelectorAll("input[type=text], input[type=number]").forEach((field) => { field.value = "" })
    this.dispatch("changed")
  }

  fields() {
    return [...this.element.querySelectorAll("input:not([type=hidden]):not([type=file]), textarea, select")]
  }

  restore() {
    let fields
    try { fields = JSON.parse(localStorage.getItem(this.storageKeyValue) || "null") } catch { return }
    if (!Array.isArray(fields)) return

    fields.forEach(([name, value]) => {
      const field = this.element.querySelector(`[name="${CSS.escape(name)}"]`)
      if (field && field.type !== "hidden" && field.type !== "file") field.value = value
    })
  }
}
